import _ from 'lodash';
import { ParentDetail, StudentDetailInfo } from '../types/studentDetailType';

export const transformParentFormData = (
  parent: ParentDetail,
  school: string
) => {
  return {
    school: school,
    email: parent.email?.trim(),
    personalDetails: parent.personalDetails,
    name: parent.name,
    educationalQualification: parent.educationalQualification,
    officialDetails: parent.officialDetails,
    occupationDetails: parent.occupationDetails
  };
};

export const transformStudentFormData = (
  studentData: StudentDetailInfo,
  schoolConfig: any
) => {
  const customFields: any[] = [];
  Object.keys(schoolConfig.userCustomFieldMapping).forEach((key, index) => {
    customFields.push({
      name: key,
      label: schoolConfig.userCustomFieldMapping[key],
      value: studentData.customFieldsMap?.[key]
    });
  });
  return {
    email: studentData.email?.trim(),
    permanentEducationNumber: studentData.permanentEducationNumber?.trim(),
    apaarId: studentData.apaarId?.trim(),
    currentDivision: _.isUndefined(studentData?.currentCourseInfo?.division)
      ? undefined
      : studentData?.currentCourseInfo?.division,
    currentHouse: _.isUndefined(studentData?.currentCourseInfo?.house)
      ? undefined
      : studentData?.currentCourseInfo?.house,
    enrollmentNo: _.isEmpty(studentData.enrollmentNo)
      ? undefined
      : studentData.enrollmentNo,
    gender: _.isEmpty(studentData.gender) ? undefined : studentData.gender,
    currentRollNo: _.isEmpty(studentData?.currentCourseInfo?.rollNo)
      ? ''
      : studentData?.currentCourseInfo?.rollNo,
    firstAdmissionClass: _.isEmpty(studentData.firstAdmissionClass)
      ? undefined
      : studentData.firstAdmissionClass,
    previousSchoolAttended: _.isEmpty(studentData.previousSchoolAttended)
      ? undefined
      : studentData.previousSchoolAttended,
    dateOfJoining: _.isEmpty(studentData.dateOfJoining)
      ? null
      : studentData.dateOfJoining,
    name: studentData.name,
    emergencyContactDetails: {
      emergencyContactPersonName: _.isEmpty(
        studentData?.emergencyContactDetails?.emergencyContactPersonName
      )
        ? undefined
        : studentData?.emergencyContactDetails?.emergencyContactPersonName,
      relationWithStudent: _.isEmpty(
        studentData?.emergencyContactDetails?.relationWithStudent
      )
        ? undefined
        : studentData?.emergencyContactDetails?.relationWithStudent,
      emergencyContactNo: _.isEmpty(
        studentData?.emergencyContactDetails?.emergencyContactNo
      )
        ? undefined
        : studentData?.emergencyContactDetails?.emergencyContactNo
    },
    personalDetails: {
      contactNo: _.isEmpty(studentData?.personalDetails?.contactNo)
        ? undefined
        : studentData?.personalDetails?.contactNo,
      nationality: _.isEmpty(studentData?.personalDetails?.nationality)
        ? undefined
        : studentData?.personalDetails?.nationality,
      country: _.isEmpty(studentData?.personalDetails?.country)
        ? undefined
        : studentData?.personalDetails?.country,
      residentialAddress: _.isEmpty(
        studentData?.personalDetails?.residentialAddress
      )
        ? undefined
        : studentData?.personalDetails?.residentialAddress,
      birthPlace: _.isEmpty(studentData?.personalDetails?.birthPlace)
        ? undefined
        : studentData?.personalDetails?.birthPlace,
      religion: _.isEmpty(studentData?.personalDetails?.religion)
        ? undefined
        : studentData?.personalDetails?.religion,
      caste: _.isEmpty(studentData?.personalDetails?.caste)
        ? undefined
        : studentData?.personalDetails?.caste,
      motherTongue: _.isEmpty(studentData?.personalDetails?.motherTongue)
        ? undefined
        : studentData?.personalDetails?.motherTongue,
      category: studentData?.personalDetails?.category || '',
      dateOfBirth: !_.isEmpty(
        studentData?.personalDetails?.dateOfBirth?.toString()
      )
        ? new Date(studentData?.personalDetails?.dateOfBirth as string)
        : null,
      bloodGroup: _.isEmpty(studentData?.personalDetails?.bloodGroup)
        ? undefined
        : studentData?.personalDetails?.bloodGroup,
      birthCity: _.isEmpty(studentData?.personalDetails?.birthCity)
        ? undefined
        : studentData?.personalDetails?.birthCity,
      birthCountry: _.isEmpty(studentData?.personalDetails?.birthCountry)
        ? undefined
        : studentData?.personalDetails?.birthCountry,
      birthDistrict: _.isEmpty(studentData?.personalDetails?.birthDistrict)
        ? undefined
        : studentData?.personalDetails?.birthDistrict,
      birthState: _.isEmpty(studentData?.personalDetails?.birthState)
        ? undefined
        : studentData?.personalDetails?.birthState,
      birthTaluka: _.isEmpty(studentData?.personalDetails?.birthTaluka)
        ? undefined
        : studentData?.personalDetails?.birthTaluka,
      resCity: _.isEmpty(studentData?.personalDetails?.resCity)
        ? undefined
        : studentData?.personalDetails?.resCity,
      weight: _.isEmpty(studentData?.personalDetails?.weight)
        ? undefined
        : studentData?.personalDetails?.weight,
      height: _.isEmpty(studentData?.personalDetails?.height)
        ? undefined
        : studentData?.personalDetails?.height,
      minority: _.isEmpty(studentData?.personalDetails?.minority)
        ? undefined
        : studentData?.personalDetails?.minority,
      resPincode: _.isEmpty(studentData?.personalDetails?.resPincode)
        ? undefined
        : studentData?.personalDetails?.resPincode
    },
    guardianInfo: {
      name: _.isEmpty(studentData.guardianInfo?.name)
        ? undefined
        : studentData.guardianInfo?.name,
      relation: _.isEmpty(studentData.guardianInfo?.relation)
        ? undefined
        : studentData.guardianInfo?.relation,
      emailId: _.isEmpty(studentData.guardianInfo?.emailId)
        ? undefined
        : studentData.guardianInfo?.emailId,
      personalDetails: {
        contactNo: _.isEmpty(
          studentData.guardianInfo?.personalDetails?.contactNo
        )
          ? undefined
          : studentData.guardianInfo?.personalDetails?.contactNo,
        nationality: studentData?.guardianInfo?.personalDetails?.nationality,
        country: studentData.guardianInfo?.personalDetails?.country,
        residentialAddress: _.isEmpty(
          studentData.guardianInfo?.personalDetails?.residentialAddress
        )
          ? undefined
          : studentData.guardianInfo?.personalDetails?.residentialAddress,
        birthPlace: studentData.guardianInfo?.personalDetails?.birthPlace,
        religion: studentData.guardianInfo?.personalDetails?.religion,
        caste: studentData.guardianInfo?.personalDetails?.caste,
        motherTongue: studentData.guardianInfo?.personalDetails?.motherTongue,
        dateOfBirth: studentData.guardianInfo?.personalDetails?.dateOfBirth,
        bloodGroup: studentData.guardianInfo?.personalDetails?.bloodGroup
      },
      officialDetails: {
        passportNo: studentData.guardianInfo?.officialDetails?.passportNo,
        passportExpiryDate:
          studentData.guardianInfo?.officialDetails?.passportExpiryDate,
        visa: studentData.guardianInfo?.officialDetails?.visa,
        adhaarCardNo: _.isEmpty(
          studentData.guardianInfo?.officialDetails?.adhaarCardNo
        )
          ? undefined
          : studentData.guardianInfo?.officialDetails?.adhaarCardNo,
        panCardNo: _.isEmpty(
          studentData.guardianInfo?.officialDetails?.panCardNo
        )
          ? undefined
          : studentData.guardianInfo?.officialDetails?.panCardNo
      },
      occupationDetails: {
        occupation: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.occupation
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.occupation,
        profession: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.profession
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.profession,
        organizationName: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.organizationName
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.organizationName,
        designation: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.designation
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.designation,
        officeContactNo: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.officeContactNo
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.officeContactNo,
        officeAddress: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.officeAddress
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.officeAddress,
        annualIncome: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.annualIncome
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.annualIncome,
        isGovermentEmployee: _.isEmpty(
          studentData.guardianInfo?.occupationDetails?.isGovermentEmployee
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails?.isGovermentEmployee,
        websiteOrLinkedInProfileUrl: _.isEmpty(
          studentData.guardianInfo?.occupationDetails
            ?.websiteOrLinkedInProfileUrl
        )
          ? undefined
          : studentData.guardianInfo?.occupationDetails
              ?.websiteOrLinkedInProfileUrl
      },
      profile: studentData.guardianInfo?.profile || '',
      category: studentData.guardianInfo?.personalDetails?.category || '',
      educationalQualification: _.isEmpty(
        studentData.guardianInfo?.educationalQualification
      )
        ? undefined
        : studentData.guardianInfo?.educationalQualification,
      department: studentData.guardianInfo?.occupationDetails?.department
    },
    officialDetails: {
      passportNo: _.isEmpty(studentData.officialDetails?.passportNo)
        ? undefined
        : studentData.officialDetails?.passportNo,
      passportExpiryDate: _.isEmpty(
        studentData.officialDetails?.passportExpiryDate
      )
        ? undefined
        : new Date(studentData.officialDetails?.passportExpiryDate || ''),
      visa: _.isEmpty(studentData.officialDetails?.visa)
        ? undefined
        : studentData.officialDetails?.visa,
      adhaarCardNo: _.isEmpty(studentData.officialDetails?.adhaarCardNo)
        ? undefined
        : studentData.officialDetails?.adhaarCardNo,
      panCardNo: studentData.officialDetails?.panCardNo
    },
    studentHealthInfo: {
      isChildTakingAnyMedication:
        studentData.studentHealthInfo?.isChildTakingAnyMedication?.toString(),
      medicationDetails: _.isEmpty(
        studentData.studentHealthInfo?.medicationDetails
      )
        ? undefined
        : studentData.studentHealthInfo?.medicationDetails,
      doesChildHaveAnyAllergies:
        studentData.studentHealthInfo?.doesChildHaveAnyAllergies?.toString(),
      allergyDetails: _.isEmpty(studentData.studentHealthInfo?.allergyDetails)
        ? undefined
        : studentData.studentHealthInfo?.allergyDetails,
      anyMedicalProblem:
        studentData.studentHealthInfo?.anyMedicalProblem?.toString(),
      medicalProblemDetails: _.isEmpty(
        studentData.studentHealthInfo?.medicalProblemDetails
      )
        ? undefined
        : studentData.studentHealthInfo?.medicalProblemDetails
    },
    medicalPractitionerInfo: {
      name: _.isEmpty(studentData.medicalPractitionerInfo?.name)
        ? undefined
        : studentData.medicalPractitionerInfo?.name,
      address: _.isEmpty(studentData.medicalPractitionerInfo?.address)
        ? undefined
        : studentData.medicalPractitionerInfo?.address,
      clinicPhoneNo: _.isEmpty(
        studentData.medicalPractitionerInfo?.clinicPhoneNo
      )
        ? undefined
        : studentData.medicalPractitionerInfo?.clinicPhoneNo,
      mobileNo: _.isEmpty(studentData.medicalPractitionerInfo?.mobileNo)
        ? undefined
        : studentData.medicalPractitionerInfo?.mobileNo
    },
    customFields: customFields,
    currentActivityClubs: studentData?.currentCourseInfo?.activityClubs ?? []
  };
};
